import { t } from 'i18next';

const upcomingType = 'Upcoming';
const historicalType = 'Historical';

const RervationsScreenTypes = {
	Upcoming: {
		isPastOrder: false,
		placeholderTKey: 'account.noUpcomingReservations',
	},
	Historical: {
		isPastOrder: true,
		placeholderTKey: 'account.noPastReservations',
	},
} as const;

type ReservationScreenTypeKey = keyof typeof RervationsScreenTypes;

class ReservationsScreenType {
	private key: ReservationScreenTypeKey;

	private constructor(key: ReservationScreenTypeKey) {
		this.key = key;
	}

	public static get upcoming(): ReservationsScreenType {
		return new ReservationsScreenType(upcomingType);
	}

	public static get historical(): ReservationsScreenType {
		return new ReservationsScreenType(historicalType);
	}

	get type() {
		return this.key;
	}

	get placeholder() {
		return t(RervationsScreenTypes[this.key].placeholderTKey);
	}

	get isPastOrder() {
		return RervationsScreenTypes[this.key].isPastOrder;
	}

	public getReservationFlowUrl(item: { main_product_reservation_flow_url?: string | null }): string | null {
		return this.isPastOrder ? (item.main_product_reservation_flow_url ?? null) : null;
	}
}

export default ReservationsScreenType;
